let firebaseConfig = {
  apiKey: "AIzaSyAypL8WS_wkdmN91KQqCy_265ftSaMmoF0",
  authDomain: "hut-bazar-ba6c8.firebaseapp.com",
  projectId: "hut-bazar-ba6c8",
  storageBucket: "hut-bazar-ba6c8.appspot.com",
  messagingSenderId: "1053782472785",
  appId: "1:1053782472785:web:6d07ecdcdd5f084a24e070"
  };
  export default firebaseConfig